<template>
  <div class="p-4 max-w-3xl mx-auto bg-white shadow rounded">
    <h2 class="text-xl font-bold mb-4">Doctor Schedule Setup</h2>

    <div class="grid grid-cols-2 gap-4 mb-3">
      <select v-model="doctor_id" class="border p-2 rounded">
        <option disabled value="">Select Doctor</option>
        <option v-for="d in doctors" :key="d.id" :value="d.id">
          {{ d.name }}
        </option>
      </select>

      <select v-model="weekday" class="border p-2 rounded">
        <option disabled value="">Select Weekday</option>
        <option v-for="d in days" :key="d" :value="d">{{ d }}</option>
      </select>

      <input type="time" v-model="start_time" class="border p-2 rounded" />
      <input type="time" v-model="end_time" class="border p-2 rounded" />

      <input type="number" v-model="max_patient" placeholder="Max Patients"
             class="col-span-2 border p-2 rounded" />
    </div>

    <button @click="addSchedule"
      class="bg-blue-500 text-white px-4 py-2 rounded">
      Add Schedule
    </button>

    <hr class="my-4" />

    <!-- List -->
    <table class="w-full border">
      <thead>
        <tr class="bg-gray-200 text-sm">
          <th class="p-2">Weekday</th>
          <th class="p-2">Time</th>
          <th class="p-2">Max</th>
          <th class="p-2">Action</th>
        </tr>
      </thead>
      <tbody>
        <tr v-for="item in schedules" :key="item.id">
          <td class="p-2">{{ item.weekday }}</td>
          <td class="p-2">{{ item.start_time }} - {{ item.end_time }}</td>
          <td class="p-2">{{ item.max_patient }}</td>
          <td class="p-2">
            <button @click="deleteRow(item.id)"
              class="text-red-500">Delete</button>
          </td>
        </tr>
      </tbody>
    </table>

  </div>
</template>

<script setup>
import axios from "axios";
import { ref } from "vue";

const doctor_id = ref("");
const weekday = ref("");
const start_time = ref("");
const end_time = ref("");
const max_patient = ref(10);
const schedules = ref([]);
const doctors = ref([
  { id: 1, name: "Dr. Rahim" },
  { id: 2, name: "Dr. Zaman" },
]);
const days = ["Sat","Sun","Mon","Tue","Wed","Thu","Fri"];

const loadSchedules = async () => {
  if (!doctor_id.value) return;
  const res = await axios.get("/api/doctor-schedules", {
    params: { doctor_id: doctor_id.value },
  });
  schedules.value = res.data;
};

const addSchedule = async () => {
  await axios.post("/api/doctor-schedules", {
    doctor_id: doctor_id.value,
    weekday: weekday.value,
    start_time: start_time.value,
    end_time: end_time.value,
    max_patient: max_patient.value,
  });
  await loadSchedules();
};

const deleteRow = async (id) => {
  await axios.delete(`/api/doctor-schedules/${id}`);
  await loadSchedules();
};
</script>
